module.exports = __webpack_public_path__ + "fonts/NeuePlakTextSemiBold_normal_normal.fa8f6de.woff";